import React from "react";
import { ShieldCheck, AlertTriangle, AlertOctagon } from "lucide-react";

/**
 * Compact, reusable risk badge. Shows healthy / at_risk / high_risk with
 * appropriate color + icon + (optional) tooltip listing the factors.
 *
 * Use sm size in lists/cards, md size in profile headers.
 */
export default function RiskBadge({ level, factors = [], size = "sm", testId }) {
  const lvl = level || "healthy";
  const meta = {
    healthy:    { label: "Healthy",   icon: ShieldCheck,  cls: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950/30 dark:text-emerald-300 dark:border-emerald-900/50" },
    at_risk:    { label: "At risk",   icon: AlertTriangle, cls: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/30 dark:text-amber-300 dark:border-amber-900/50" },
    high_risk:  { label: "High risk", icon: AlertOctagon,  cls: "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-950/30 dark:text-rose-300 dark:border-rose-900/50" },
  }[lvl] || { label: lvl, icon: ShieldCheck, cls: "bg-slate-100 text-slate-700 border-slate-200" };

  const Icon = meta.icon;
  const sizeCls = size === "md"
    ? "px-2.5 py-1 text-[11px] gap-1"
    : "px-1.5 py-0.5 text-[10px] gap-0.5";
  const iconCls = size === "md" ? "w-3 h-3" : "w-2.5 h-2.5";

  const title = factors.length > 0 ? factors.join(" · ") : meta.label;

  return (
    <span
      data-testid={testId || `risk-badge-${lvl}`}
      title={title}
      className={`inline-flex items-center font-semibold uppercase tracking-wide rounded-md border ${meta.cls} ${sizeCls}`}
    >
      <Icon className={iconCls} strokeWidth={2.4} />
      {meta.label}
    </span>
  );
}
